// ======================================================================
// File Name       : ParticipantSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, InputGroup, Button } from 'react-bootstrap';
import Datetime from 'react-datetime';
import RenderField from '../../../utils/ReduxFormUtils';
import ReduxFormPaging from '../../ReduxFormPaging';
import { convertNodeGroupToNodeString } from '../../../utils/UserUtils';
import CustomButton from '../../button/CustomButton';

class ParticipantSearch extends React.Component {
  render() {
    const {
      selectGroup,
      groupList,
      selectedTargetGroup,
      removeSelectedGroup,
      recordNum,
      getStartEndData,
      clickSearchButton,
      searchCondition,
    } = this.props;
    let groupName = null;
    if (searchCondition && searchCondition.selectedTargetGroup) {
      const groupSecernId = searchCondition.selectedTargetGroup.groupSecernId;
      groupName = convertNodeGroupToNodeString(groupSecernId, groupList);
    }
    if (selectedTargetGroup && selectedTargetGroup.groupSecernId) {
      const groupSecernId = selectedTargetGroup.groupSecernId;
      groupName = convertNodeGroupToNodeString(groupSecernId, groupList);
    }
    return (
      <div>
        <h3>検索する項目を指定してください</h3>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            clickSearchButton();
          }}
          className='form-horizontal'
        >
          <Col sm={12} className="padding-top-10">
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                ユーザー名
              </Col>
              <Col sm={7}>
                <RenderField type="text" name="userName" label="ユーザー名" value='' />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                ユーザーグループ名</Col>
              <Col sm={2}>
                <Button
                  variant="primary"
                  className="btn-96"
                  onClick={selectGroup}
                >
                  グループ選択
                </Button>
              </Col>
            </Form.Group>
            {groupName && (
              <Form.Group className="form-info">
                <Col sm={7} md={{
                  offset: 3
                }} as={Form.Label}>
                  {groupName}
                </Col>
                <Col sm={2}>
                  <Button variant="primary" className="btn-96" onClick={removeSelectedGroup}>
                    削除
                  </Button>
                </Col>
              </Form.Group>
            )}
          </Col>
          <Form.Group className="text-center">
            <Col sm={12}>
              <CustomButton
                btnStyle="btn btn-primary btn-96 margin-top-20"
                type="submit"
                text="検索"
                iconClass="bi bi-search"
              />
            </Col>
          </Form.Group>
        </Form>
      </div>
    );
  }
}

export default ParticipantSearch;
